import { render, staticRenderFns } from "./IncheonAirportDataInterface.vue?vue&type=template&id=c7f25142&scoped=true&"
import script from "./IncheonAirportDataInterface.vue?vue&type=script&lang=js&"
export * from "./IncheonAirportDataInterface.vue?vue&type=script&lang=js&"
import style0 from "./IncheonAirportDataInterface.vue?vue&type=style&index=0&id=c7f25142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f25142",
  null
  
)

export default component.exports